module.exports = __webpack_public_path__ + "img/2019qinglongxia-1.31c39845.jpg";